import { NgModule } from '@angular/core';
import { CommonModule} from '@angular/common';
import { RespondentsModule } from '../respondents/respondents.module';
import { ReportsModule } from '../reports/reports.module';
import { ProjectService } from './project.service';
import { ProjectComponent } from './project.component';
import { QuestionnaireProjectModule } from './questionnaireProject/questionnaire-project.module';
import { QuestionnaireViewModule } from './questionnaireView/questionnaire-view.module';
import { CreateQuestionnaireModule } from './createQuestionnaire/create-questionnaire.module';
import { ProjectInfosModule } from './projectInfo/project-infos.module';
import { QuestionnaireNodeModule } from './questionnaireNode/questionnaire-node.module';
import { ProjectNavbarModule } from './projectNavBar/project-navbar.module';
import {LoginModule} from '../loading-animation/loading.module';
import {GenericModalModule} from '../modal/generic-modal.module';


@NgModule({
    imports: [
        CommonModule,
        RespondentsModule,
        ReportsModule,
        QuestionnaireNodeModule,
        QuestionnaireViewModule,
        QuestionnaireProjectModule,
        CreateQuestionnaireModule,
        ProjectInfosModule,
        ProjectNavbarModule,
        LoginModule,
        GenericModalModule
    ],
    declarations: [ProjectComponent],
    providers: [ ProjectService ],
    exports: [ ProjectComponent]
})
export class ProjectModule {

}
